module.exports = __webpack_public_path__ + "static/img/halloween_banner_bg.2d0ad6f.png";